import type { AddressExtensionAttributes, AddressRegion, CasAddressStored } from "../../../types";

import type { Builder } from "./Builder";

export class AddressDataBuilder implements Builder<CasAddressStored> {
  _body: CasAddressStored = {
    id: "3980",
    city: "Berlin",
    country_code: "DE",
    default_billing: false,
    street: ["Schönhauser Allee", "1"],
    lastname: "address lastname",
    postcode: "60-541",
    firstname: "address firstname",
    telephone: "49123456789",
    country_id: "DE",
    default_shipping: true,
    administrative_area_level_2: "Berlin Province",
    sublocality_level_2: "Mitte",
    extension_attributes: { subscription: false },
    building_number: "12",
    district: "district",
    landmark: "Brandenburg Gate",
    neighborhood: "Prenzlauer Berg",
    premise: "Prenzlauer Allee 1",
    region: { region: "Alba", region_code: "AL", region_id: 15 },
    short_address: null,
  };

  setId(value: string | number): this {
    this._body.id = value;
    return this;
  }

  setCity(value: string): this {
    this._body.city = value;
    return this;
  }

  setCountryCode(value: string): this {
    this._body.country_code = value;
    return this;
  }

  setDefaultBilling(value: boolean): this {
    this._body.default_billing = value;
    return this;
  }

  setStreet(value: string[]): this {
    this._body.street = value;
    return this;
  }

  setLastname(value: string): this {
    this._body.lastname = value;
    return this;
  }

  setPostcode(value: string | null): this {
    this._body.postcode = value;
    return this;
  }

  setFirstname(value: string | null): this {
    this._body.firstname = value;
    return this;
  }

  setTelephone(value: string | null): this {
    this._body.telephone = value;
    return this;
  }

  setCountryId(value: string): this {
    this._body.country_id = value;
    return this;
  }

  setDefaultShipping(value: boolean): this {
    this._body.default_shipping = value;
    return this;
  }

  setAdministrativeAreaLevel2(value: string | null): this {
    this._body.administrative_area_level_2 = value;
    return this;
  }

  setSublocalityLevel2(value: string | null): this {
    this._body.sublocality_level_2 = value;
    return this;
  }

  setExtensionAttributes(value: AddressExtensionAttributes): this {
    this._body.extension_attributes = value;
    return this;
  }

  setBuildingNumber(value: string | null): this {
    this._body.building_number = value;
    return this;
  }

  setDistrict(value: string | null): this {
    this._body.district = value;
    return this;
  }

  setLandmark(value: string | null): this {
    this._body.landmark = value;
    return this;
  }

  setNeighborhood(value: string | null): this {
    this._body.neighborhood = value;
    return this;
  }

  setPremise(value: string | null): this {
    this._body.premise = value;
    return this;
  }

  setRegion(value: AddressRegion): this {
    this._body.region = value;
    return this;
  }

  setShortAddress(value: string | null | undefined): this {
    this._body.short_address = value;
    return this;
  }

  build(): CasAddressStored {
    return this._body;
  }
}
